import { IUploadPopUpRef } from "../UploadPopUp";
import styles from "./styles.module.css";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { useSetAtom, useAtomValue } from "jotai";
import { homepageFeatureAtom, segmentEventPayload } from "@/modules/editor-v2/Atoms";
import { useSelector } from "react-redux";
import { Skeleton } from "@mui/material";
import { useSearchParams } from "next/navigation";
import { openFileUploaderAtom } from "@/modules/marketplaceListing/Atoms";
import { ICONS } from "@/modules/ui-elements/Icon";
import { EventTrackName } from "@/modules/segment-event-tracking/constant";
import { TrackWebappEvent } from "@/modules/segment-event-tracking/segmentEventTracking";
import InternalWork from '../InternalWork';

export default function AIBckgrounds({
  popUpRef,
}: {
  popUpRef: React.MutableRefObject<IUploadPopUpRef>;
}) {
  const getSegmentPayloadAtom = useAtomValue(segmentEventPayload);
  const strapiData:any = useSelector<any>(state=>state.strapi?.entireStrapiData?.StaggeredListItemType?.StaggeredListItemType);
  const router = useRouter();

  const searchParams = useSearchParams();
  const toolType = searchParams.get("toolType");
  const setHomepageFeature = useSetAtom(homepageFeatureAtom);

  // useEffect(() => {
    // const title = 'AI Backgrounds';
    // if (Object.keys(getSegmentPayloadAtom || {}).length && toolType) {
    //   switch (toolType) {
    //     case "aiBackgrounds":
    //       // onClickGenerator(title, toolsList[0].WidgetImage)();
    //       break;
    //     default:
    //       break;
    //   }
    // }
  // }, [searchParams, getSegmentPayloadAtom]);

  const toolsList = [
    {
      title: strapiData?.AIBackgroundsText || "AI Backgrounds",
      image: strapiData?.AIBackgroundsURL || "/images/home/AIBackgrounds.png",
      extraData: {
          type: "aiBackgrounds"
      },
      WidgetImage: strapiData?.AIBackgroundsWidgetImageURL || "/images/home/515.jpg",
    }
  ]

  const onUploadFailure =
    () =>
    async ({ error }) => {
      // popUpRef.current.close()
    };

  // const onSingleImageUploadSuccessGenerator = () => async (jobData) => {
  //   if (!jobData || Object.keys(jobData).length === 0) return;
  //   const jobId = jobData?.job_id;
  //   router.push("/dashboard/editor/" + jobId + "?AI-backgrounds");
  //   popUpRef.current.close();
  //   return;
  // };

  // const onClickGenerator =
  //   (title: string, WidgetImage?: string) => () => {
  //     const singleImageBulkUpload = true;
  //     const newQuery = { ...router.query };
  //     delete newQuery?.toolType;
  //     router.replace(
  //       { pathname: router.pathname, query: newQuery },
  //       undefined,
  //       { shallow: true }
  //     );

  //   setHomepageFeature('AI Backgrounds');
  //   const eventPayload = {
  //     homepageFeature: 'AI Backgrounds',
  //     ...getSegmentPayloadAtom,
  //   };
  //   TrackWebappEvent(
  //     `${process.env.NEXT_PUBLIC_EVENT_TRACK_TYPE}${EventTrackName._select_tool_hp}`,
  //     eventPayload
  //   );

  //     popUpRef.current.open({
  //       title,
  //       singleImageBulkUpload: singleImageBulkUpload,
  //       widgetImage: WidgetImage,
  //       onUploadFailure: onUploadFailure(),
  //       onSingleImageBulkUpload: onSingleImageUploadSuccessGenerator(),
  //     });
  //   };

  return (
    <div className={styles.container}>
      <div className={styles.heading}>
        {strapiData?.ReferencingSubHeading || "Create high engagement content"}
      </div>
      <div className={styles.toolsContainer}>
        <div className={styles.listContainer}>
          {/* {!toolsList ? (
            <>
              {Array(1)
                .fill(0)
                ?.map((_) => (
                  <Skeleton
                    animation={"wave"}
                    variant={"rectangular"}
                    width={216}
                    height={148}
                    style={{ marginRight: 6, borderRadius: 0 }}
                  />
                ))}
            </>
          ) : <>
            {toolsList.map((item) => (
              <div
                className={styles.listItem}
                onClick={onClickGenerator(
                  item?.title,
                  item.WidgetImage
                )}
              >
                <img
                  src={item.image}
                  className={styles.listImage}
                />
                <div className={styles.listItemTitleContainer}>
                  <div className={`${styles.listItemTitle} user-selection-disable`}>
                    <span>{item.title}</span>
                    <img src={ICONS.rightArrowVector} style={{ color: '#FFFFFF !important' }} alt="" height={10} />
                  </div>
                </div>
              </div>
            ))}
          </>} */}
            <InternalWork popUpRef={popUpRef} />
        </div>
      </div>
    </div>
  );
}
